//export const BASE_URL: string = 'https://airnesiagroupapi-training.intelisys.ca/api/';
export const BASE_URL: string = 'https://airnesiagroupapi.intelisys.ca/api/';

export const TIME_REFRESH_TOKEN: number = 15000;
export const TIME_REFRESH_FARE_RESULT: number = 30;
